import { useState } from "react";
import { G } from "../../constants/theme";

export default function TeamCard({ m }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: hovered ? G.surface : G.card,
        padding: "44px 32px 36px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        borderRight: `1px solid ${G.border}`,
        transition: "background .25s",
        position: "relative",
      }}
    >
      {/* Top accent bar */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: 2,
          background: hovered ? G.green : "transparent",
          transition: "background .25s",
        }}
      />

      {/* Photo */}
      <div style={{ position: "relative", marginBottom: 20 }}>
        <div
          style={{
            width: 118,
            height: 118,
            borderRadius: "50%",
            overflow: "hidden",
            border: `2px solid ${hovered ? G.green : G.greenDim}`,
            boxShadow: hovered
              ? "0 0 32px rgba(76,175,80,.22)"
              : "0 0 16px rgba(76,175,80,.08)",
            transition: "all .25s",
          }}
        >
          <img
            src={m.img}
            alt={m.name}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center top",
            }}
          />
        </div>
        <div
          style={{
            position: "absolute",
            bottom: -10,
            left: "50%",
            transform: "translateX(-50%)",
            background: G.green,
            color: G.black,
            fontFamily: "monospace",
            fontSize: 8,
            letterSpacing: 2,
            padding: "4px 12px",
            whiteSpace: "nowrap",
            textTransform: "uppercase",
            fontWeight: 700,
          }}
        >
          {m.badge}
        </div>
      </div>

      {/* Name & role */}
      <div style={{ marginTop: 16 }}>
        <div
          style={{
            fontFamily: "'Bebas Neue', sans-serif",
            fontSize: 27,
            color: G.white,
            letterSpacing: 2,
            lineHeight: 1,
            marginBottom: 6,
          }}
        >
          {m.name}
        </div>
        <div
          style={{
            fontFamily: "monospace",
            fontSize: 9,
            letterSpacing: 2,
            color: G.green,
            textTransform: "uppercase",
            marginBottom: 4,
          }}
        >
          {m.role}
        </div>
        {m.location && (
          <div
            style={{
              fontFamily: "monospace",
              fontSize: 9,
              letterSpacing: 1.5,
              color: G.muted,
              textTransform: "uppercase",
            }}
          >
            📍 {m.location}
          </div>
        )}
      </div>

      {/* Divider */}
      <div style={{ width: 36, height: 1, background: G.border, margin: "18px auto" }} />

      {/* Bio */}
      <p style={{ fontSize: 13, color: G.muted, lineHeight: 1.7, marginBottom: 20, flexGrow: 1 }}>
        {m.bio}
      </p>

      {/* Email */}
      {m.email && (
        <a
          href={`mailto:${m.email}`}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            marginBottom: 16,
            color: G.green,
            fontFamily: "monospace",
            fontSize: 10,
            letterSpacing: 0.5,
            wordBreak: "break-all",
          }}
        >
          <span style={{ fontSize: 12 }}>✉</span>
          {m.email}
        </a>
      )}

      {/* Tags */}
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", justifyContent: "center" }}>
        {m.tags.map((tag) => (
          <span
            key={tag}
            style={{
              background: G.surface,
              border: `1px solid ${G.border}`,
              fontFamily: "monospace",
              fontSize: 8,
              letterSpacing: 1,
              color: G.muted,
              padding: "5px 10px",
              textTransform: "uppercase",
            }}
          >
            {tag}
          </span>
        ))}
      </div>
    </div>
  );
}
